import { Table } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTable = styled(Table)(({ theme }) => ({
    borderCollapse: "separate",
    borderSpacing: `0px ${theme.spacing(0.4)}`,
}));

export { PeekTable, PeekTable as default };
